(function ($) {
  DJ.addBehavior('jcfCheckboxesInit', '.js-filters-aside-checkboxes', {
    attach: function () {
      const formWrapper = this;
      const checkboxes = formWrapper.querySelectorAll('input[type="checkbox"]');

      if (checkboxes) {
        jcf.replace(checkboxes, 'Checkbox');
      }
    }
  });
})(jQuery);
